import { Trans, useTranslation } from 'react-i18next';
import { Alert, Box, Stack } from '@mui/material';
import { Modal } from '../../Modal';
import { ProgressField } from '../../ProgressField';
import * as Icons from '../../icons';
import type { StartupStepProps } from '../StartupWizard.types';

export const ResetRequiredStep = ({ messages, onNext, isMobile = false }: StartupStepProps) => {
  const { t } = useTranslation('startupWizard');
  const fields = messages['components/container_data']?.payload.fields;
  const isProcessStopActive = fields?.is_process_stop_active === true;
  const isFireAlarmActive = fields?.is_fire_alarm_active === true;
  const isCleared = !isProcessStopActive && !isFireAlarmActive;

  const resets = [
    { title: t('resetRequired.processStop'), isCleared: !isProcessStopActive },
    { title: t('resetRequired.fireAlarm'), isCleared: !isFireAlarmActive },
  ];

  return (
    <Modal
      isOpen
      title={t('resetRequired.title')}
      maxWidth="md"
      isMobile={isMobile}
      onCancel={onNext}
      cancelButtonTitle={t('dismiss')}
      cancelButtonAlign="left"
      data-testid="reset-required-modal"
    >
      <Stack spacing={3} pt={1}>
        <Alert severity={isCleared ? 'success' : 'info'} sx={{ '& strong': { fontWeight: 600 } }}>
          {isCleared ? t('resetRequired.resetStarted') : <Trans t={t} i18nKey="resetRequired.instructions" />}
        </Alert>
        <Stack direction={isMobile ? 'column' : 'row'} spacing={2}>
          {resets.map(({ title, isCleared: isResetCleared }) => (
            <Box key={title} flex={1} p={2} borderRadius={2} bgcolor={(theme) => theme.palette.background.lightGrey}>
              <ProgressField
                title={title}
                inProgress={!isResetCleared}
                inProgressLabel={t('resetRequired.pressOnPanel')}
                doneLabel={t('resetRequired.cleared')}
                inProgressIcon={<Icons.ErrorOutline color="error" sx={{ fontSize: '32px' }} />}
              />
            </Box>
          ))}
        </Stack>
      </Stack>
    </Modal>
  );
};
